/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Collection of all possible modes that can be assigned to geoblocking or IP blocking
 */
export enum AllowDenyMode {
  allow = "allow",
  deny = "deny",
}

/**
 * Collection of all possible analytics range types
 */
export enum AnalyticsRangeType {
  daily = "daily",
  monthly = "monthly",
}

/**
 * Collection of all possible auth cred types
 */
export enum AuthCredTypeEnum {
  auto = "auto",
  maintenance = "maintenance",
  scheduler = "scheduler",
  token = "token",
  user = "user",
}

/**
 * Collection of all possible bitrate modes a channel can have
 */
export enum BitrateMode {
  constant = "constant",
  variable = "variable",
}

/**
 * Collection of all possible modes that can be assigned to geoblocking or IP blocking
 */
export enum BlockingModeEnum {
  blacklist = "blacklist",
  whitelist = "whitelist",
}

/**
 * Collection of all possible CDN types
 */
export enum CdnType {
  akamai = "akamai",
  fastly = "fastly",
}

/**
 * Collection of all possible modes a channel can have
 */
export enum ChannelModeType {
  demo = "demo",
  locked = "locked",
  production = "production",
  promotional = "promotional",
}

/**
 * Collection of all possible statuses a channel can have
 */
export enum ChannelStatusType {
  creating = "creating",
  deleted = "deleted",
  deleting = "deleting",
  deploying = "deploying",
  error = "error",
  ingesting = "ingesting",
  playing = "playing",
  scheduled = "scheduled",
  starting = "starting",
  stopped = "stopped",
  stopping = "stopping",
  waiting = "waiting",
}

/**
 * Collection of all possible contract types an organization can have
 */
export enum ContractType {
  commitment = "commitment",
  payg = "payg",
}

/**
 * Collection of all possible subsets
 */
export enum EventSubsetType {
  action = "action",
  log = "log",
}

/**
 * Collection of all possible events
 */
export enum EventType {
  alias_created = "alias_created",
  alias_deleted = "alias_deleted",
  alias_deleting = "alias_deleting",
  alias_disabled = "alias_disabled",
  alias_enabled = "alias_enabled",
  alias_updated = "alias_updated",
  all = "all",
  channel_created = "channel_created",
  channel_creating = "channel_creating",
  channel_deleted = "channel_deleted",
  channel_deleting = "channel_deleting",
  channel_deploying = "channel_deploying",
  channel_error = "channel_error",
  channel_ingesting = "channel_ingesting",
  channel_log_error = "channel_log_error",
  channel_log_info = "channel_log_info",
  channel_log_warn = "channel_log_warn",
  channel_playing = "channel_playing",
  channel_scheduled = "channel_scheduled",
  channel_starting = "channel_starting",
  channel_stopped = "channel_stopped",
  channel_stopping = "channel_stopping",
  channel_updated = "channel_updated",
  channel_waiting = "channel_waiting",
  scheduler_active = "scheduler_active",
  scheduler_created = "scheduler_created",
  scheduler_deleted = "scheduler_deleted",
  scheduler_starting = "scheduler_starting",
  scheduler_terminated = "scheduler_terminated",
  scheduler_updated = "scheduler_updated",
  webhook_created = "webhook_created",
  webhook_deleted = "webhook_deleted",
  webhook_disabled = "webhook_disabled",
  webhook_enabled = "webhook_enabled",
  webhook_updated = "webhook_updated",
}

/**
 * Collection of all possible fallback types a channel can have
 */
export enum FallbackType {
  dash = "dash",
  hls = "hls",
  theo_live = "theo_live",
}

/**
 * Collection of all ingest protocols THEOlive supports
 */
export enum IngestProtocol {
  ndi = "ndi",
  rtmp = "rtmp",
  rtsp = "rtsp",
  sdi = "sdi",
  srt = "srt",
}

/**
 * Collection of all possible ingest types
 */
export enum IngestType {
  pull = "pull",
  push = "push",
}

/**
 * Collection of all possible statuses an invoice can have
 */
export enum InvoiceStatusType {
  deleted = "deleted",
  draft = "draft",
  open = "open",
  paid = "paid",
  uncollectible = "uncollectible",
  void = "void",
}

/**
 * Collection of all types a recurring maintenance can have
 */
export enum MaintenanceRecurringPeriodType {
  days = "days",
  month = "month",
  weeks = "weeks",
}

/**
 * Collection of all types a maintenance can have
 */
export enum MaintenanceType {
  recurring = "recurring",
  scheduled = "scheduled",
}

/**
 * Collection of possible order directions
 */
export enum OrderDirectionType {
  asc = "asc",
  desc = "desc",
}

/**
 * Collection of all possible statuses an organization can have
 */
export enum OrganizationStatusType {
  demo = "demo",
  locked = "locked",
  production = "production",
}

/**
 * Collection of all possible overage types a contract can have
 */
export enum OverageType {
  monthly = "monthly",
  yearly = "yearly",
}

/**
 * Collection of all possible resolutions
 */
export enum ResolutionType {
  r_1080p = "r_1080p",
  r_240p = "r_240p",
  r_360p = "r_360p",
  r_576p = "r_576p",
  r_720p = "r_720p",
}

/**
 * Collection of all possible phases a scheduler can have
 */
export enum SchedulerPhaseType {
  active = "active",
  deleted = "deleted",
  pending = "pending",
  starting = "starting",
  terminated = "terminated",
}

/**
 * Collection of all possible types a report can have
 */
export enum SchedulerReportType {
  available = "available",
  generating = "generating",
  unavailable = "unavailable",
}

/**
 * Collection of all possible TLA hardware interface decklink gst modes types
 */
export enum TLAHardewareInterfaceGstDecklinkModesType {
  Auto = "Auto",
  EightK2398 = "EightK2398",
  EightK24 = "EightK24",
  EightK25 = "EightK25",
  EightK2997 = "EightK2997",
  EightK30 = "EightK30",
  EightK50 = "EightK50",
  EightK5994 = "EightK5994",
  EightK60 = "EightK60",
  EightKDCIP2398 = "EightKDCIP2398",
  EightKDCIP24 = "EightKDCIP24",
  EightKDCIP25 = "EightKDCIP25",
  EightKDCIP2997 = "EightKDCIP2997",
  EightKDCIP30 = "EightKDCIP30",
  EightKDCIP50 = "EightKDCIP50",
  EightKDCIP5994 = "EightKDCIP5994",
  EightKDCIP60 = "EightKDCIP60",
  FourK2398 = "FourK2398",
  FourK24 = "FourK24",
  FourK25 = "FourK25",
  FourK2997 = "FourK2997",
  FourK30 = "FourK30",
  FourK50 = "FourK50",
  FourK5994 = "FourK5994",
  FourK60 = "FourK60",
  FourKDCIP2398 = "FourKDCIP2398",
  FourKDCIP24 = "FourKDCIP24",
  FourKDCIP25 = "FourKDCIP25",
  FourKDCIP2997 = "FourKDCIP2997",
  FourKDCIP30 = "FourKDCIP30",
  FourKDCIP50 = "FourKDCIP50",
  FourKDCIP5994 = "FourKDCIP5994",
  FourKDCIP60 = "FourKDCIP60",
  HD1080I50 = "HD1080I50",
  HD1080I5994 = "HD1080I5994",
  HD1080I60 = "HD1080I60",
  HD1080P2398 = "HD1080P2398",
  HD1080P24 = "HD1080P24",
  HD1080P25 = "HD1080P25",
  HD1080P2997 = "HD1080P2997",
  HD1080P30 = "HD1080P30",
  HD1080P50 = "HD1080P50",
  HD1080P5994 = "HD1080P5994",
  HD1080P60 = "HD1080P60",
  HD720P50 = "HD720P50",
  HD720P5994 = "HD720P5994",
  HD720P60 = "HD720P60",
  NTSC = "NTSC",
  NTSC2398 = "NTSC2398",
  NTSC2398Widescreen = "NTSC2398Widescreen",
  NTSCP = "NTSCP",
  NTSCPWidescreen = "NTSCPWidescreen",
  NTSCWidescreen = "NTSCWidescreen",
  PAL = "PAL",
  PALP = "PALP",
  PALPWidescreen = "PALPWidescreen",
  PALWidescreen = "PALWidescreen",
  TwoK2398 = "TwoK2398",
  TwoK24 = "TwoK24",
  TwoK25 = "TwoK25",
  TwoKDCIP2398 = "TwoKDCIP2398",
  TwoKDCIP24 = "TwoKDCIP24",
  TwoKDCIP25 = "TwoKDCIP25",
  TwoKDCIP2997 = "TwoKDCIP2997",
  TwoKDCIP30 = "TwoKDCIP30",
  TwoKDCIP50 = "TwoKDCIP50",
  TwoKDCIP5994 = "TwoKDCIP5994",
  TwoKDCIP60 = "TwoKDCIP60",
}

/**
 * Collection of all possible TLA hardware interface decklink profile types
 */
export enum TLAHardewareInterfaceGstDecklinkProfileIdType {
  Default = "Default",
  FourSubDevicesHalf = "FourSubDevicesHalf",
  OneSubDeviceFull = "OneSubDeviceFull",
  OneSubDeviceHalf = "OneSubDeviceHalf",
  TwoSubDevicesFull = "TwoSubDevicesFull",
  TwoSubDevicesHalf = "TwoSubDevicesHalf",
}

/**
 * Collection of all possible TLA hardware interface decklink video format types
 */
export enum TLAHardewareInterfaceGstDecklinkVideoFormatType {
  Auto = "Auto",
  EightBitARGB = "EightBitARGB",
  EightBitBGRA = "EightBitBGRA",
  EightBitYUV = "EightBitYUV",
  TenBitRGB = "TenBitRGB",
  TenBitYUV = "TenBitYUV",
}

/**
 * Collection of all possible TLA hardware interface decklink connection types
 */
export enum TLAHardwareInterfaceDecklinkConnectionType {
  Auto = "Auto",
  Component = "Component",
  Composite = "Composite",
  HDMI = "HDMI",
  OpticalSDI = "OpticalSDI",
  SDI = "SDI",
  SVideo = "SVideo",
}

/**
 * Collection of all possible usage types
 */
export enum UsageType {
  transcoded = "transcoded",
  viewed = "viewed",
}

/**
 * Collection of all possible roles a user can have
 */
export enum UserRoleType {
  hesp_admin = "hesp_admin",
  hesp_theo_admin = "hesp_theo_admin",
  hesp_theo_admin_sales = "hesp_theo_admin_sales",
  hesp_user = "hesp_user",
}

export enum ViewerInsightsIntervalType {
  day = "day",
  hour = "hour",
  minute = "minute",
}

/**
 * Collection of all possible viewing source types
 */
export enum ViewingSourceType {
  fallback__dash = "fallback__dash",
  fallback__hls = "fallback__hls",
  fallback__theo_live = "fallback__theo_live",
  primary = "primary",
}

export interface AbrEntryInput {
  resolution: string;
  bitRate: number;
}

export interface AbrLadderInput {
  entries: AbrEntryInput[];
}

export interface ActivateAccountInput {
  code: string;
  email: string;
  password: string;
}

export interface AddCdnSecurityJwtKeyInput {
  organizationId: string;
  channelId: string;
  aliasId: string;
  key: TokenSecurityKeyInput;
}

export interface AddDatacenterToOrganizationInput {
  organizationId: string;
  datacenterId: string;
}

export interface AddPaymentMethodInput {
  organizationId: string;
  paymentMethodId: string;
}

export interface AddUserInput {
  email: string;
  role: UserRoleType;
  organizationId: string;
}

export interface AddV2DistributionKeyArgsInput {
  key: string;
  name?: string | null;
}

export interface AddV2DistributionKeyInput {
  organizationId: string;
  id: string;
  args: AddV2DistributionKeyArgsInput;
}

export interface AssetKeyInput {
  assetKey: string;
  adBreakSelectionParameters: KeyValuePairInput[];
  eabnAdTagParameters: KeyValuePairInput[];
}

export interface ChangeChannelModeInput {
  channelId: string;
  channelMode: ChannelModeType;
}

export interface ChangeIngestTypeInput {
  channelId: string;
  organizationId: string;
  ingestType: IngestType;
  ingestProtocol: IngestProtocol;
  audio?: ChannelStreamConfigAudioInput[] | null;
  captions?: ChannelStreamConfigCaptionInput[] | null;
  ingestPullUrl?: string | null;
  sdi?: ChannelSdiInput | null;
}

export interface ChangeOrganizationNameInput {
  organizationId: string;
  newName: string;
}

export interface ChangeOrganizationStatusInput {
  organizationId: string;
  newStatus: OrganizationStatusType;
}

export interface ChangeOrganizationTypeInput {
  isIndividual: boolean;
  organizationId: string;
}

export interface ChangePasswordInput {
  password: string;
}

export interface ChannelAdsSettingsInput {
  assetKey?: string | null;
  layout: string;
  enableBumperAds: boolean;
  podDuration: number;
}

export interface ChannelCustomizationInput {
  targetLatency?: number | null;
}

export interface ChannelEngineInput {
  override: ChannelEngineOverrideInput;
}

export interface ChannelEngineOverrideInput {
  enabled: boolean;
  image: string;
}

export interface ChannelHlsInput {
  enabled: boolean;
}

export interface ChannelMetadataEnhancedLoggingInput {
  enabled: boolean;
  percentage: number;
}

export interface ChannelMetadataInsightsInput {
  enabled: boolean;
}

export interface ChannelPricingInput {
  enabled: boolean;
  transcoded: number;
  viewed: number;
  drm: number;
}

export interface ChannelSdiInput {
  persistentId: string;
  deviceNumber?: number | null;
  audioConnection: TLAHardwareInterfaceDecklinkConnectionType;
  videoConnection: TLAHardwareInterfaceDecklinkConnectionType;
  videoFormat: TLAHardewareInterfaceGstDecklinkVideoFormatType;
  videoMode: TLAHardewareInterfaceGstDecklinkModesType;
  profile: TLAHardewareInterfaceGstDecklinkProfileIdType;
}

export interface ChannelStreamConfigAudioInput {
  pid?: number | null;
  lang: string;
  label: string;
}

export interface ChannelStreamConfigCaptionInput {
  channel: number;
  language: string;
  label: string;
}

export interface ChannelStreamConfigInput {
  abr: boolean;
  drm: boolean;
  fps: number;
  bitrate: number;
  resolution: ResolutionType;
  bitrateMode: BitrateMode;
  publishUrl: string;
  restream: RestreamInput[];
  skipTranscode?: boolean | null;
}

export interface CloneV2DistributionInput {
  organizationId: string;
  distributionId: string;
  name: string;
}

export interface ConvertChannelToTLAInput {
  channelId: string;
  organizationId: string;
  ingestPullUrl: string;
  ingestProtocol: IngestProtocol;
  datacenterId: string;
}

export interface CopyAliasConfigInput {
  copyFromId: string;
  copyFromChannelId: string;
  organizationId: string;
  fromIsAlias: boolean;
  copyToId: string;
  copyToChannelId: string;
  toIsAlias: boolean;
}

export interface CreateChannelAliasInput {
  channelId: string;
  organizationId: string;
  name: string;
}

export interface CreateChannelInput {
  organizationId: string;
  ingestLocation?: string | null;
  datacenterId?: string | null;
  sdi?: ChannelSdiInput | null;
  ingestProtocol?: IngestProtocol | null;
  ingestType?: IngestType | null;
  ingestPullUrl?: string | null;
  metadata: CreateChannelMetadataInput;
  streamConfig: ChannelStreamConfigInput;
  ingestTimeout: number;
  perpetual?: boolean | null;
  theoads?: THEOadsInput | null;
}

export interface CreateChannelMetadataInput {
  name: string;
  externalId?: string | null;
}

export interface CreateChannelV2Input {
  organizationId: string;
  name: string;
  externalId?: string | null;
  ads?: UpdateChannelAdsInput | null;
  dvr?: UpdateChannelDvrInput | null;
  nielsen?: UpdateChannelNielsenInput | null;
}

export interface CreateContractInput {
  organizationId: string;
  start: string;
  end: string;
  overageType: OverageType;
  billInGb: boolean;
  hasAccessToSD: boolean;
  gbUsedPerMinute: number;
}

export interface CreateDataCenterCertificatesInput {
  name: string;
  source: string;
}

export interface CreateDataCenterFQDNIInput {
  ingest: string;
  origins: string;
}

export interface CreateDatacenterInput {
  id: string;
  name: string;
  tlaName: string;
  tlaDescription: string;
  labels: string[];
  tlaDomain?: string | null;
  tlaHostId?: string | null;
  tlaRegion?: string | null;
  tlaProvider?: string | null;
  tlaHttp3?: boolean | null;
  tlaLetsEncrypt?: boolean | null;
  tlaTLS?: boolean | null;
  override?: string | null;
  fqdn?: CreateDataCenterFQDNIInput | null;
  certificates?: CreateDataCenterCertificatesInput[] | null;
}

export interface CreateDeviceContextForDatacenterInput {
  id: string;
  name: string;
  description: string;
  serial: string;
  privateId: string;
  capacity: number;
  labels: string[];
  privateIp?: string | null;
  joinToken?: string | null;
  isCluster?: boolean | null;
  override?: string | null;
}

export interface CreateDistributionArgs {
  name: string;
  endpoints: CreateDistributionEndpoints;
}

export interface CreateDistributionEndpoints {
  engineIds: string[];
  cdns: UpdateDistributionEndpointsCdns;
}

export interface CreateEngineArgs {
  name: string;
  priority: number;
  region: string;
  encoderPreset: string;
  ingestId: string;
  drm: boolean;
  daiAssetKey?: string | null;
  outputs: V2DistributionOutputsInput;
  quality: V2EngineCreateQualityInput;
}

export interface CreateIngestArgs {
  type: string;
  url: string;
  name: string;
  region?: string | null;
}

export interface CreateInstallContextForDatacenterInput {
  id: string;
  name?: string | null;
  description?: string | null;
  labels: string[];
  nodeLabels: string[];
  privateId?: string | null;
  disableVaultSSH?: boolean | null;
  upgradeDocker?: boolean | null;
  privateCIDR?: string | null;
}

export interface CreateProfileInput {
  maxBitrate: number;
  organizationId: string;
  maxResolution: string;
  maxFps: number;
  publiclyAvailable: boolean;
  transcodedPricePerMinute: number;
  viewedPricePerMinute: number;
  abrLadder: AbrLadderInput;
}

export interface CreateReportInput {
  organizationId: string;
  name: string;
  start: string;
  end: string;
  clientId: string;
  metadata: KeyValuePairInput[];
  channelIds: string[];
}

export interface CreateSchedulerInput {
  organizationId: string;
  name: string;
  startNow: boolean;
  start: string;
  end?: string | null;
  clientId: string;
  metadata: KeyValuePairInput[];
  channelIds: string[];
  recurring: SchedulerRecurringInput;
}

export interface CreateTokenInput {
  organizationId: string;
  name: string;
}

export interface CreateV2DistributionInput {
  organizationId: string;
  channelId: string;
  args: CreateDistributionArgs;
}

export interface CreateV2EngineInput {
  organizationId: string;
  channelId: string;
  args: CreateEngineArgs;
}

export interface CreateV2IngestInput {
  organizationId: string;
  channelId: string;
  args: CreateIngestArgs;
}

export interface CreateWebhookInput {
  organizationId: string;
  name: string;
  description?: string | null;
  url: string;
  events: string[];
  isAdmin?: boolean | null;
}

export interface DeleteChannelAliasInput {
  channelAliasId: string;
  channelId: string;
  organizationId: string;
}

export interface DeleteChannelInput {
  channelId: string;
  organizationId: string;
}

export interface DeleteDeviceContextInput {
  id: string;
}

export interface DeleteInstallContextInput {
  id: string;
}

export interface DeleteOrganizationInput {
  organizationId: string;
}

export interface DeleteSchedulerInput {
  schedulerId: string;
  organizationId: string;
}

export interface DeleteUserInput {
  auth0Id: string;
}

export interface DeleteV2DistributionKeyInput {
  organizationId: string;
  id: string;
  keyId: string;
}

export interface DeleteV2DistributionKeysInput {
  organizationId: string;
  id: string;
}

export interface DeleteV2ObjectInput {
  organizationId: string;
  id: string;
}

export interface DeleteWebhookInput {
  webhookId: string;
  organizationId: string;
}

export interface DeviceContextSdiInputInput {
  name: string;
  deviceNumber: number;
  persistentId: string;
}

export interface DisableChannelAliasInput {
  channelAliasId: string;
  channelId: string;
  organizationId: string;
}

export interface DistributionDvrInput {
  enabled: boolean;
}

export interface DistributionEndpointsCdnInput {
  weight: number;
}

export interface DistributionGeoBlockingInput {
  enabled: boolean;
  mode: AllowDenyMode;
  countries: string[];
}

export interface DistributionIpBlockingInput {
  enabled: boolean;
  mode: AllowDenyMode;
  cidrs: string[];
}

export interface DistributionRefererBlockingInput {
  enabled: boolean;
  allowedDomains: string[];
  allowNativeApps: boolean;
}

export interface DistributionWebRtcInput {
  priority?: number | null;
  src?: DistributionWebRtcSrcInput | null;
}

export interface DistributionWebRtcSrcInput {
  accountId: string;
  name: string;
  apiUrl: string;
}

export interface EnableChannelAliasInput {
  channelAliasId: string;
  channelId: string;
  organizationId: string;
}

export interface EnablePaygInput {
  organizationId: string;
}

export interface KeyValuePairInput {
  key: string;
  value: string;
}

export interface MaintenanceIntervalInput {
  period: MaintenanceRecurringPeriodType;
  amount: number;
  time: string;
}

export interface MaintenanceSlotInput {
  day: string;
  time: string;
}

export interface ManageBillingDetailsInput {
  organizationId: string;
  isIndividual: boolean;
  email: string;
  name: string;
  street: string;
  zip: string;
  city: string;
  state: string;
  country: string;
  vat: string;
}

export interface ManageChannelTokenSecurityInput {
  organizationId: string;
  channelId: string;
  parentChannelId: string;
  isAlias: boolean;
  enable: boolean;
  version: number;
  keys: TokenSecurityKeyInput[];
}

export interface OrganizationQuotasInput {
  organizationId: string;
  maxReportsPerDay: number;
}

export interface OriginSecurityInput {
  enabled: boolean;
}

export interface RegisterWithEmailInput {
  email: string;
  password: string;
}

export interface RemoveCdnSecurityJwtKey {
  organizationId: string;
  channelId: string;
  aliasId: string;
  keyId: string;
}

export interface RemoveDatacenterInput {
  datacenterId: string;
}

export interface RemoveTLADatacenterFromOrganizationInput {
  organizationId: string;
  datacenterId: string;
}

export interface RequestChangePasswordInput {
  email: string;
}

export interface RequestDrmAccessInput {
  organizationId: string;
}

export interface ResendActivationLinkInput {
  auth0Id: string;
}

export interface RestreamInput {
  id: string;
  url: string;
}

export interface RevokeTokenInput {
  tokenKey: string;
}

export interface RunBootstrapsInput {
  id: string;
}

export interface SchedulerRecurringInput {
  enabled: boolean;
  days: number[];
  tz?: string | null;
}

export interface StartChannelInput {
  channelId: string;
  organizationId: string;
}

export interface StartSchedulerInput {
  schedulerId: string;
  organizationId: string;
}

export interface StartStopV2ObjectInput {
  organizationId: string;
  id: string;
}

export interface StopChannelInput {
  channelId: string;
  organizationId: string;
}

export interface THEOadsInput {
  enabled: boolean;
  assetKeys: AssetKeyInput[];
  podDuration: number;
}

export interface TerminateSchedulerInput {
  schedulerId: string;
  organizationId: string;
}

export interface TokenSecurityKeyInput {
  id: string;
  key: string;
}

export interface UpdateAliasFallbackInput {
  enabled: boolean;
  channelId: string;
  channelAliasId: string;
  organizationId: string;
  type?: string | null;
  src?: string | null;
}

export interface UpdateChannelAdminSettingsInput {
  channelId: string;
  organizationId: string;
  enhancedLogging: ChannelMetadataEnhancedLoggingInput;
  insights: ChannelMetadataInsightsInput;
  originSecurity: OriginSecurityInput;
  pricing: ChannelPricingInput;
  engine: ChannelEngineInput;
}

export interface UpdateChannelAdsInput {
  enabled: boolean;
  settings?: ChannelAdsSettingsInput | null;
}

export interface UpdateChannelAliasInput {
  channelAliasId: string;
  channelId: string;
  organizationId: string;
  name?: string | null;
  customization?: ChannelCustomizationInput | null;
  publicationUpdates?: UpdatePublicationConfigInput | null;
  hls?: ChannelHlsInput | null;
}

export interface UpdateChannelDatacenterInput {
  channelId: string;
  datacenterId: string;
  organizationId: string;
}

export interface UpdateChannelDvrInput {
  enabled: boolean;
  windowInSeconds: number;
}

export interface UpdateChannelExternalIdInput {
  channelId: string;
  organizationId: string;
  externalId: string;
}

export interface UpdateChannelInput {
  channelId: string;
  organizationId: string;
  metadata?: UpdateChannelMetadataInput | null;
  publicationUpdates?: UpdatePublicationConfigInput | null;
  perpetual?: boolean | null;
  ingestTimeout?: number | null;
  theoads?: THEOadsInput | null;
  hls?: ChannelHlsInput | null;
}

export interface UpdateChannelMaintenanceInput {
  channelId: string;
  organizationId: string;
  isCustom: boolean;
  maintenance?: UpdateMaintenanceInput | null;
}

export interface UpdateChannelMetadataInput {
  name?: string | null;
  externalId?: string | null;
  customization?: ChannelCustomizationInput | null;
}

export interface UpdateChannelNielsenInput {
  enabled: boolean;
}

export interface UpdateChannelV2Input {
  channelId: string;
  organizationId: string;
  name?: string | null;
  externalId?: string | null;
  ads?: UpdateChannelAdsInput | null;
  dvr?: UpdateChannelDvrInput | null;
  nielsen?: UpdateChannelNielsenInput | null;
}

export interface UpdateContractInput {
  organizationId: string;
  contractId: string;
  billInGb?: boolean | null;
  hasAccessToSD?: boolean | null;
  gbUsedPerMinute?: number | null;
}

export interface UpdateDatacenterInput {
  id: string;
  newId?: string | null;
  name?: string | null;
  tlaDescription?: string | null;
  tlaDomain?: string | null;
  tlaHostId?: string | null;
  tlaRegion?: string | null;
  tlaProvider?: string | null;
  tlaHttp3?: boolean | null;
  tlaLetsEncrypt?: boolean | null;
  tlaTLS?: boolean | null;
  labels?: string[] | null;
  override?: string | null;
  fqdn?: CreateDataCenterFQDNIInput | null;
  certificates?: CreateDataCenterCertificatesInput[] | null;
}

export interface UpdateDeviceContextInput {
  id: string;
  name: string;
  description: string;
  capacity: number;
  labels: string[];
  privateIp?: string | null;
  joinToken?: string | null;
  isCluster?: boolean | null;
  override?: string | null;
}

export interface UpdateDeviceContextSdiInputs {
  id: string;
  sdiInputs: DeviceContextSdiInputInput[];
}

export interface UpdateDistributionArgs {
  name?: string | null;
  enabled?: boolean | null;
  targetLatency?: number | null;
  maxBitrate?: number | null;
  parameters?: KeyValuePairInput[] | null;
  security?: UpdateDistributionSecurity | null;
  endpoints?: UpdateDistributionEndpoints | null;
  outputs?: V2DistributionOutputsInput | null;
  webRtc?: DistributionWebRtcInput | null;
  dvr?: DistributionDvrInput | null;
}

export interface UpdateDistributionEndpoints {
  engineIds?: string[] | null;
  cdns?: UpdateDistributionEndpointsCdns | null;
}

export interface UpdateDistributionEndpointsCdns {
  fastly?: DistributionEndpointsCdnInput | null;
  akamai?: DistributionEndpointsCdnInput | null;
}

export interface UpdateDistributionInput {
  id: string;
  organizationId: string;
  updates: UpdateDistributionArgs;
}

export interface UpdateDistributionSecurity {
  geoBlocking?: DistributionGeoBlockingInput | null;
  ipBlocking?: DistributionIpBlockingInput | null;
  refererBlocking?: DistributionRefererBlockingInput | null;
  skipJwtChecks?: boolean | null;
}

export interface UpdateFallbackInput {
  enabled: boolean;
  channelId: string;
  organizationId: string;
  type?: string | null;
  src?: string | null;
}

export interface UpdateIngestPullUrlInput {
  channelId: string;
  organizationId: string;
  ingestPullUrl: string;
}

export interface UpdateInstallContextInput {
  id: string;
  name?: string | null;
  description?: string | null;
  labels: string[];
  nodeLabels: string[];
  privateId?: string | null;
  disableVaultSSH?: boolean | null;
  upgradeDocker?: boolean | null;
  privateCIDR?: string | null;
}

export interface UpdateMaintenanceInput {
  type: MaintenanceType;
  slots?: MaintenanceSlotInput[] | null;
  interval?: MaintenanceIntervalInput | null;
}

export interface UpdateOrganizationChannelSettingsDomainInput {
  override: UpdateOrganizationChannelSettingsDomainOverrideInput;
}

export interface UpdateOrganizationChannelSettingsDomainOverrideInput {
  enabled: boolean;
  defaultDomain: string;
}

export interface UpdateOrganizationChannelSettingsDrmInput {
  enabled: boolean;
}

export interface UpdateOrganizationChannelSettingsEngineInput {
  override: UpdateOrganizationChannelSettingsEngineOverrideInput;
}

export interface UpdateOrganizationChannelSettingsEngineOverrideInput {
  enabled: boolean;
  image: string;
}

export interface UpdateOrganizationChannelSettingsHybridFallbackInput {
  enabled: boolean;
}

export interface UpdateOrganizationChannelSettingsInput {
  organizationId: string;
  hybridFallback: UpdateOrganizationChannelSettingsHybridFallbackInput;
  perpetual: UpdateOrganizationChannelSettingsPerpetualInput;
  drm: UpdateOrganizationChannelSettingsDrmInput;
  engine: UpdateOrganizationChannelSettingsEngineInput;
  domain: UpdateOrganizationChannelSettingsDomainInput;
  theoads: UpdateOrganizationChannelSettingsTHEOadsInput;
  maxMobileBitrate: UpdateOrganizationChannelSettingsMaxMobileBitrateInput;
  v2: UpdateOrganizationChannelSettingsV2Input;
}

export interface UpdateOrganizationChannelSettingsMaxMobileBitrateInput {
  enabled: boolean;
  max?: number | null;
}

export interface UpdateOrganizationChannelSettingsPerpetualInput {
  enabled: boolean;
}

export interface UpdateOrganizationChannelSettingsTHEOadsInput {
  enabled: boolean;
  adsUrl: string;
  googleDaiNetworkCode: string;
  sseCdnEndpointUrl: string;
}

export interface UpdateOrganizationChannelSettingsV2Input {
  enabled: boolean;
}

export interface UpdateOrganizationMaintenanceInput {
  organizationId: string;
  maintenance: UpdateMaintenanceInput;
}

export interface UpdateOrganizationTLASettingsInput {
  organizationId: string;
  activated: boolean;
}

export interface UpdatePaygPricingInput {
  organizationId: string;
  transcodingCost: number;
  viewingCost: number;
}

export interface UpdateProfileInput {
  id: string;
  maxBitrate: number;
  maxResolution: string;
  maxFps: number;
  publiclyAvailable: boolean;
  transcodedPricePerMinute: number;
  viewedPricePerMinute: number;
  abrLadder: AbrLadderInput;
}

export interface UpdatePublicationCdnInput {
  provider: CdnType;
  url: string;
  defaultDomain: string;
}

export interface UpdatePublicationConfigInput {
  geoblockingUpdates?: UpdatePublicationGeoblockingInput | null;
  ipBlockingUpdates?: UpdatePublicationIpBlockingInput | null;
  cdnUpdates?: UpdatePublicationCdnInput | null;
}

export interface UpdatePublicationGeoblockingInput {
  enabled: boolean;
  countries: string[];
  mode: BlockingModeEnum;
}

export interface UpdatePublicationIpBlockingInput {
  enabled: boolean;
  cidrs: string[];
  mode: BlockingModeEnum;
}

export interface UpdateReportInput {
  reportId: string;
  organizationId: string;
  name: string;
  start: string;
  end: string;
  clientId: string;
  metadata: KeyValuePairInput[];
  channelIds: string[];
}

export interface UpdateSchedulerInput {
  schedulerId: string;
  organizationId: string;
  name: string;
  start?: string | null;
  end?: string | null;
  clientId: string;
  metadata: KeyValuePairInput[];
  channelIds: string[];
  recurring: SchedulerRecurringInput;
}

export interface UpdateSchedulerReportInput {
  schedulerId: string;
  organizationId: string;
  start: string;
  end: string;
}

export interface UpdateStreamConfigInput {
  channelId: string;
  organizationId: string;
  fps: number;
  bitrate: number;
  resolution: ResolutionType;
  abr: boolean;
  drm: boolean;
  bitrateMode: BitrateMode;
  publishUrl: string;
  restream: RestreamInput[];
  skipTranscode?: boolean | null;
}

export interface UpdateUserInput {
  auth0Id: string;
  role: UserRoleType;
}

export interface UpdateUserProfileInput {
  firstName: string;
  lastName: string;
  phone: string;
}

export interface UpdateV2EngineArgs {
  name?: string | null;
  priority?: number | null;
  region?: string | null;
  ingestId?: string | null;
  quality?: V2EngineUpdateQualityInput | null;
  encoderPreset?: string | null;
  drm?: boolean | null;
  daiAssetKey?: string | null;
  outputs?: V2DistributionOutputsInput | null;
  override?: V2EngineOverrideInput | null;
}

export interface UpdateV2EngineInput {
  id: string;
  organizationId: string;
  updates: UpdateV2EngineArgs;
}

export interface UpdateV2IngestArgs {
  name?: string | null;
  url?: string | null;
  type?: string | null;
  region?: string | null;
  captions?: UpdateV2IngestCaptionInput[] | null;
  tracks?: UpdateV2IngestTracksInput | null;
}

export interface UpdateV2IngestAudioInput {
  pid?: number | null;
  language: string;
  label?: string | null;
}

export interface UpdateV2IngestCaptionInput {
  channel: number;
  language: string;
  label?: string | null;
}

export interface UpdateV2IngestInput {
  id: string;
  organizationId: string;
  updates: UpdateV2IngestArgs;
}

export interface UpdateV2IngestTracksInput {
  audio?: UpdateV2IngestAudioInput[] | null;
}

export interface UpdateWebhookInput {
  webhookId: string;
  organizationId: string;
  name?: string | null;
  description?: string | null;
  url?: string | null;
  events?: string[] | null;
  active?: boolean | null;
}

export interface V2DistributionOutputsInput {
  hesp: boolean;
  hls: boolean;
  hlsMpegTs: boolean;
}

export interface V2EngineCreateQualityInput {
  abrLadderId: string;
}

export interface V2EngineOverrideInput {
  image?: string | null;
}

export interface V2EngineUpdateQualityInput {
  abrLadderId?: string | null;
}

export interface VerifiedAccountInput {
  email: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
